<div class="inset-0 flex flex-col border overflow-hidden">


<app-navbar></app-navbar>

<div class="grow bg-white flex flex-row gap-6 overflow-hidden">
  <div class="overflow-y-scroll">
    <div *ngFor="let heading of headings">
      <a (click)="scrollTo(heading.id)">{{heading.title}}</a>
    </div>
  </div>

  <div class="prose overflow-y-scroll" >
    <app-markdown [markup]="markup" [trustHtml]="true"></app-markdown>
  </div>
</div>
</div>


